
import Links from '@library/components/Atoms/Link/Links.vue'
import Typography from '@library/components/Atoms/Typography/Typography.vue'
export default {
  props: {
    labels: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Links,
    Typography
  },
  methods: {
    closeModal(e) {
      if (e === 'close') {
        this.$emit('closeModal')
      }
    }
  }
}
